import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/rechargeGift/blue_calender.png'
import _imports_1 from '@/assets/rechargeGift/green_calender.png'
import _imports_2 from '@/assets/rechargeGift/red_calender.png'
import _imports_3 from '@/assets/rechargeGift/coin.png'
import _imports_4 from '@/assets/common/calender.png'


const _hoisted_1 = { class: "cardSubContainer" }
const _hoisted_2 = { class: "calendar-wrapper" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  width: "75px",
  style: {"border-radius":"10px"}
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  width: "75px",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  width: "75px",
  style: {"border-radius":"10px"}
}
const _hoisted_6 = { class: "calendar" }
const _hoisted_7 = { class: "cal-header" }
const _hoisted_8 = { class: "cal-body" }
const _hoisted_9 = { class: "month" }
const _hoisted_10 = { class: "day" }
const _hoisted_11 = { class: "stats-section" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_14 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_15 = {
  key: 3,
  style: {"color":"#ff0000"}
}
const _hoisted_16 = { class: "stats-grid" }
const _hoisted_17 = { class: "stat-item" }
const _hoisted_18 = { class: "value yellow" }
const _hoisted_19 = { class: "stat-item" }
const _hoisted_20 = { class: "value yellow" }
const _hoisted_21 = { class: "dayImage2" }
const _hoisted_22 = {
  class: "dateText",
  style: {"font-size":"12px"}
}
const _hoisted_23 = {
  class: "dayTitle",
  style: {"font-size":"12px"}
}
const _hoisted_24 = { style: {"padding-left":"10px"} }
const _hoisted_25 = { class: "right-texts" }
const _hoisted_26 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_27 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_28 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_29 = {
  key: 3,
  style: {"color":"#ff0000"}
}
const _hoisted_30 = { class: "dayCard" }
const _hoisted_31 = { class: "dayTitle" }

import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { computed, PropType, ref, } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackWeekDayCard',
  props: {
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
},
  setup(__props) {

const props = __props
const dateObj = computed(() => {
    if (!props.createTime) return new Date();
    const dateString = props.createTime;
    return new Date(dateString);
});

const year = computed(() => dateObj.value.getFullYear());
const day = computed(() => dateObj.value.getDate());
const month = computed(() => dateObj.value.toLocaleString('en-US', { month: 'long' }));

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cardContainer", __props.activityStatus == 1 ? 'claimCard' : __props.activityStatus == 2 ? 'norewardCard' : __props.activityStatus == 3 ? 'norewardCard' : __props.activityStatus == 0 ? 'pendingCard' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["refund-card", __props.activityStatus == 1 ? 'refund-card' : __props.activityStatus == 2 ? 'refund-card-2' : __props.activityStatus == 3 ? 'refund-card-2' : __props.activityStatus == 0 ? 'refund-card-1' : ''])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["check-badge", __props.activityStatus == 1 ? 'check-badge' : __props.activityStatus == 2 ? 'check-badge-2' : __props.activityStatus == 3 ? 'check-badge-2' : __props.activityStatus == 0 ? 'check-badge-1' : ''])
        }, [
          (__props.activityStatus == 0)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "underway-o ",
                color: "#b8b2b2"
              }))
            : _createCommentVNode("", true),
          (__props.activityStatus == 1)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                name: "success"
              }))
            : _createCommentVNode("", true),
          (__props.activityStatus == 2 || __props.activityStatus == 3)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 2,
                name: "cross",
                color: "#ffadad"
              }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_2, [
          (__props.activityStatus == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : _createCommentVNode("", true),
          (__props.activityStatus == 1)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true),
          (__props.activityStatus == 2 || __props.activityStatus == 3)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(year.value), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(month.value), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(day.value), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["status-badge", __props.activityStatus == 1 ? 'status-badge' : __props.activityStatus == 2 ? 'status-badge-2' : __props.activityStatus == 3 ? 'status-badge-2' : __props.activityStatus == 0 ? 'status-badge-1' : ''])
          }, [
            (props.activityStatus == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
              : (props.activityStatus == 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                : (props.activityStatus == 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                  : (props.activityStatus == 3)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                    : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, { span: "11" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(__props.title), 1),
                      _createElementVNode("span", _hoisted_18, [
                        _createTextVNode(_toDisplayString(_unref(formatCurrency)(__props.totalAmount)), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("img", {
                          src: _imports_3,
                          alt: "",
                          width: "12%",
                          style: {"padding-left":"5%"}
                        }, null, -1))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, { span: "1" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "divider" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, { span: "11" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('activity.cashBackTotal')), 1),
                      _createElementVNode("span", _hoisted_20, [
                        _createTextVNode(_toDisplayString(__props.dayList ? _unref(formatCurrency)(_unref(getAmountSum)(__props.dayList)) :
                                        _unref(formatCurrency)(0)), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("img", {
                          src: _imports_3,
                          alt: "",
                          width: "12%",
                          style: {"padding-left":"5%"}
                        }, null, -1))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ]),
    (!__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 0,
          style: _normalizeStyle({ borderBottom: __props.isShowDetails ? '#80808070 dashed 2px' : '' })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    src: _imports_4,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(__props.createTime?.split(' ')[0]), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "topRow",
              style: {"margin":"10px 0"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.givenAmount')) + " : ", 1),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(formatCurrency)(__props.givenAmount)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "6",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_25, [
                  (props.activityStatus == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                    : (props.activityStatus == 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                      : (props.activityStatus == 2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                        : (props.activityStatus == 3)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                          : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_row, {
      style: {"display":"flex","justify-content":"center","padding-bottom":"10px"},
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        (__props.dayList && __props.dayList?.length > 0)
          ? (_openBlock(), _createBlock(_component_van_col, {
              key: 0,
              span: "24",
              style: {"display":"flex","justify-content":"center","align-items":"center","color":"#aac1e7a2","padding-bottom":"10px"}
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "line" }, null, -1),
                _createElementVNode("div", null, "DETALHES DO REEMBOLSO", -1),
                _createElementVNode("div", { class: "line" }, null, -1)
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayList, (i, index) => {
          return (_openBlock(), _createBlock(_component_van_col, {
            span: "4",
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString((_unref(dayFormat)(i.date, 0))), 1),
                _createElementVNode("div", {
                  style: _normalizeStyle({ color: __props.activityStatus == 1 ? '#36d8368a' : __props.activityStatus == 2 || __props.activityStatus == 3 ? '#dc3d3d8a' : __props.activityStatus == 0 ? '#3d9edc8a' : '' })
                }, _toDisplayString(_unref(formatCurrency)(i.amount)), 5)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 2))
}
}

})